export const APPLICATION_PATH =
  "/vacancies/:vacancyId/applications/:applicationId";
